const config = {
  apiKey: "AIzaSyAlofm0c1H8Ewibv_at-IMbwC8ZunnYJu0",
  authDomain: "quizzer-8f861.firebaseapp.com",
  databaseURL: "https://quizzer-8f861.firebaseio.com",
  projectId: "quizzer-8f861",
  storageBucket: "",
  messagingSenderId: "1039879874326",
  appId: "1:1039879874326:web:9134cb18055dea31255237"
};

export default config;
